import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import {
  ReadingSkillsPerformanceFilters,
  ReadingSkillsPerformanceResponse,
} from "@/reports/types";

export const readingSkillsPerformanceQueries = {
  all: () => [ApiCatalog.readingSkillsPerformance.key] as const,
  filter: (queryParams: ReadingSkillsPerformanceFilters, enabled = true) =>
    queryOptions({
      queryKey: [...readingSkillsPerformanceQueries.all(), { ...queryParams }],
      queryFn: () =>
        api().get<ReadingSkillsPerformanceResponse>(
          ApiCatalog.readingSkillsPerformance.endpoint,
          {
            queryParams,
          },
        ),
      enabled,
    }),
};
